

























import {Vue, Component, Prop} from 'vue-property-decorator'
import NotificationIcon from '../../../../assets/svg/points.svg';
import PlusIcon from '../../../../assets/svg/notification-plus.svg';
import MinusIcon from '../../../../assets/svg/notification-minus.svg';
import {Notification as NotificationModel} from "../../../../api/models/notifications/Notification";
import {UserProfile} from "../../../../api/models/UserProfile";
import {declOfNums} from "../../../../service/helpers/languageHelper";

@Component({
    components: { NotificationIcon, PlusIcon, MinusIcon }
})
export default class NotificationPoints extends Vue {
    @Prop() notification: NotificationModel;
    @Prop() author: UserProfile;

    get isRead(): boolean {
        return this.notification.isRead;
    }

    get currentLocale(): string {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "ru";
    }

    plural(number: number, titles: string[]): string {
        return declOfNums(number, titles);
    }

}
